export const Colors = {
  primary: "#FEA101",
  grey100: "#F5F5F5",
  grey200: "#E8E8E8",
  grey300: "#DDD",
  grey400: "#CDCDCD",
  grey500: "#909090",
  grey600: "#4E4E4E",
  grey700: "#1E1E1E",
  grey900: "#131313",
  grey1000: "#0D0D0D",
  white100: "#FFFFFF",
  white200: "#FBFBFB",
  white300: "#F5F5F5",
  yellow100: "#FED998",
  yellow300: "#FEC667",
  yellow400: "#FEB73D",
  yellow500: "#FEA101",
  yellow600: "#C07A00",
  purple100: "#C8C3FF",
  purple200: "#8478FF",
  success: "#5AB400",
  dangerFade: "rgba(255, 51, 51, 0.10)",
  danger: "#FF3333"
};
